$("._show-review-form").click(function () {
    $(this).hide()
    $(".review-form").slideToggle()
})

$(".product-info__show").click(function () {
    $(this).parents(".product-info").toggleClass("_active")
    $(this).siblings(".product-info__hidden").slideToggle()
})

$(window).on('load resize', function(){
    if ($(window).width() <= 992) {
        $('.catalog-item2 .gallery').insertAfter('.catalog-item2__top');
    } else{
        $('.catalog-item2 .gallery').insertBefore('.may-like-items');
    }
});

$(".gallery__small").each(function (index,el) {
    let slidesCount = $(el).find(".swiper-slide").length
    console.log(slidesCount)
    if(slidesCount < 7){
        $(el).addClass("_hide-arrows")
    }else{
        $(el).removeClass("_hide-arrows")
    }
})
